export type WorklogSortBy =
  | 'patient_last_name'
  | 'patient_first_name'
  | 'clinic'
  | 'episode_start_date'
  | 'task_name'
  | 'task_target_date'
  | 'action_taken'
  | 'date_action_taken'
  | 'username';

/**
 * Array of all WorklogSortBy values.
 */
export const WORKLOGSORTBY_VALUES: readonly WorklogSortBy[] = [
  'patient_last_name',
  'patient_first_name',
  'clinic',
  'episode_start_date',
  'task_name',
  'task_target_date',
  'action_taken',
  'date_action_taken',
  'username',
] as const;
